import React, { ReactNode, useMemo } from 'react'
import StatusItem, { IStatusItemProps } from './status-item'
// @ts-ignore
import IdleGIF from '../assets/idle.gif'

import './styles/status.css'
import ScanComplete from './scan-complete'

type TStatusItem =
  | {
      message: string
      icon?: string | React.ReactNode
      render?: IStatusItemProps['render']
      slotProps?: IStatusItemProps['slotProps']
    }
  | {
      render: IStatusItemProps['render']
      message?: string
      icon?: string
      slotProps?: IStatusItemProps['slotProps']
    }

export type TStatusMap = {
  [key: string]: TStatusItem
}

interface IStatusesProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  children: ReactNode
  status: string
  // onSetup: (defaultStatusList: TDefaultStatusList) => void
  statusMap: TStatusMap | null
}

export const defaultStatusMap: TStatusMap = {
  idle: {
    message: 'Place an object in the screening zone',
    icon: IdleGIF,
    slotProps: {
      icon: {
        style: {
          width: '150px',
          height: '150px',
        },
      },
    },
  },
  motion: {
    message: 'Motion detected',
  },
  scanning: {
    message: 'Scanning for details',
  },
  not_recognized: {
    message:
      'Product not recognized. Please hold the product closer to the camera',
  },
  product_placement: {
    message: 'Place the product with the label facing up in the scanning area',
  },
  center_scan: {
    message: 'Move product label inside scanning zone',
  },
  glare_scan: {
    message: 'Move product label to avoid glare',
  },
  scanned: {
    render: () => <ScanComplete />,
  },
  camera_loading: {
    message: 'Loading Camera ...',
  },
}

export default function ScannerStatus({
  children,
  status,
  // onSetup,
  statusMap,
  ...restProps
}: IStatusesProps) {
  // useEffect(() => {
  //   onSetup(defaultStatusList)
  // }, [])

  const finalStatusMap = useMemo(() => {
    return statusMap ?? defaultStatusMap
  }, [statusMap])

  const findStatusByKeyword = () => {
    if (!status) return null

    const statusDetails = finalStatusMap[status]

    if (!statusDetails) return <StatusItem message={status} />
    return (
      <StatusItem
        message={statusDetails.message}
        icon={statusDetails.icon}
        render={statusDetails.render}
        slotProps={'slotProps' in statusDetails ? statusDetails.slotProps : {}}
      />
    )
  }

  return (
    <div
      {...restProps}
      style={{
        position: 'relative',
        ...restProps.style,
      }}
    >
      {children}
      {findStatusByKeyword()}
    </div>
  )
}
